import React, {useState, useEffect} from 'react';
import styles from '../../../assets/styles/modules/Newsinfo.module.css'
import {Helmet} from 'react-helmet';
import { getKeywordRelatedStockAPI, getSingleNewsAPI, getSingleNewsCurateAPI} from "../../../apis/news_service";
import WordCloudChart from "./WordCloudChart";
import StockInfoCard from "./StockInfoCard";
import NewsKeywordCard from "./NewsKeywordCard";
import SingleNewsCard from "./SingleNewsCard";
import SameNewsSideBar from "./SameNewsSideBar";


const NewsInfo = ({newsId, keywords, setKeywordNewsList}) => {

    const [news, setNews] = useState(null) // 단일 뉴스 데이터
    const [relatedCorp, setRelatedCorps] = useState([]); // 해당 이슈를 공유하는 기업들 (두번째 상자)
    const [curate, setCurate] = useState(null); //기업 큐레이팅 정보 (세번째 상자)

    /*뉴스 관련 데이터 - 큐레이팅, 키워드*/
    const getNewsData = () => {
        getSingleNewsAPI(newsId)
            .then(res => {
                return res[0]
            })
            .then(res => {
                setNews(res)
                getSingleNewsCurateAPI(res.stockcode, '3').then(res => setCurate(res.curatetext))
            })

    }

    useEffect(getNewsData, [newsId])


    const keywordBtnClick = (idx) => {
        if(keywords.length>0){
            getKeywordRelatedStockAPI(keywords[idx].keyword).then(res => {setRelatedCorps(res)})
        }
    }

    return (
        <>
            {news &&
                <>
                    <Helmet>
                        <title>{news.subject}(newssalad.com)</title>
                    </Helmet>
                    <SingleNewsCard news={news}/>
                    <SameNewsSideBar newsId={newsId}/>
                    <div className={styles.info_container}>
                        <NewsKeywordCard news={news} keywords={keywords} keywordBtnClick={keywordBtnClick} setKeywordNewsList={setKeywordNewsList} />
                        <WordCloudChart relatedCorp={relatedCorp}/>
                        <StockInfoCard news={news} curate={curate}/>
                    </div>
                </>
            }
        </>
    )
};

export default NewsInfo;